import { getUrlParamsFetch, handleAxiosError } from "@/shared";
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from "@/shared/constants";
import { IDataSolicitudTraslado, IDataSolicitudTrasladoParams, ISolicitudTrasladoForm, ISolicitudTrasladoInventario, UseMutationsParams } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { get, post, put, remove } = erpApi();

//SOLICITUD DE INVENTARIO
export const useFetchCreateSolicitudTransferenciaProducto = ({
  enableSuccessAlert = true,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({
    mutationFn: postSolicitudTransferenciaProducto,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-traslado'] });

      enableSuccessAlert &&
        setAlert(true, data.message, data.status);
    },
    onError: (error) => {
      handleAxiosError(error)
    },
    onSettled: () => {
      setIsGlobalLoading(false);

    }
  });
};

export const postSolicitudTransferenciaProducto = async (
  data: ISolicitudTrasladoForm
) => {
  const resp = await post<IDataSolicitudTraslado>(
    `${urlBackend}api/v1/solicitud-traslado/`,
    data,
    true
  );
  return resp;
};

//OBTENER SOLICITUD TRANSFERENCIA DE INVENTARIO

export const useFetchGetSolicitudTransferenciaInventario = (
  params?: IDataSolicitudTrasladoParams,
  enabled = true
) => {
  return useQuery({
    queryKey: ['solicitud-traslado', ...Object.values(params || {})],
    queryFn: async () => {
      return await getSolicitudTransferenciaInventario(params);
    },
    enabled,
  });
};

export const getSolicitudTransferenciaInventario = async (
  params?: IDataSolicitudTrasladoParams
) => {
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<ISolicitudTrasladoInventario>(
    `${urlBackend}api/v1/solicitud-traslado/?${queryParams}`,
    true
  );
  return resp;
};

//OBTENER SOLICITUD DE TRANSFERENCIA POR ID

export const useFetchSolicitudTransferenciaInventarioById = (id: string) => {
  return useQuery({
    queryKey: ['solicitud-traslado', id],
    queryFn: async () => {
      return await getSolicitudTransferenciaInventarioById(id);
    },
  });
};

export const getSolicitudTransferenciaInventarioById = async (id: string) => {
  const resp = await get<IDataSolicitudTraslado>(
    `${urlBackend}api/v1/solicitud-traslado/${id}`,
    true
  );
  return resp.data;
};


///* actualizar solicitud de traslado

export const useFetchPutSolicitudTraslado = () => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({
    mutationFn: async ({ id, data }: {
      id: string,
      data: IDataSolicitudTrasladoParams
    }) => {
      return putSolicitudTrasladoInventario(id, data);
    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    }
  });
}

export const putSolicitudTrasladoInventario = async (
  id: string,
  data: IDataSolicitudTrasladoParams
) => {
  const resp = await put<IDataSolicitudTraslado>(
    `${urlBackend}api/v1/solicitud-traslado/${id}/`,
    data,
    true
  );
  return resp;
};


/// eliminar solicitud de transferencia

export const removeSolicitudTransferencia = async (id: string) => {
  await remove(`${urlBackend}api/v1/solicitud-traslado/${id}/`, true)
}